import { createConfig, hydrate } from '@wagmi/core';
let _config = null;
let _initParams = null;
let _external = false;
export function setEvmConfigInitParams(params) {
    if (_config)
        return;
    _initParams = params;
}
export function provideExternalEvmConfig(cfg) {
    if (_config && _config !== cfg) {
        // eslint-disable-next-line no-console
        console.warn('[evm] External wagmi config ignored — the EVM package already created or adopted '
            + 'a config before the external one was supplied. The widget will keep using the '
            + 'existing config, so the host\'s config and the widget can hold divergent '
            + 'connection state. Pass `wagmiConfig` before anything calls getEvmConfig().');
        return;
    }
    _config = cfg;
    _external = true;
}
export function getEvmConfig() {
    if (_config)
        return _config;
    if (!_initParams) {
        throw new Error('EVM wagmi config requested before setEvmConfigInitParams was called');
    }
    _config = createConfig({
        chains: _initParams.chains,
        transports: _initParams.transports,
        connectors: _initParams.connectors,
        ssr: _initParams.ssr ?? true,
    });
    // Mirrors the old <WagmiProvider reconnectOnMount={true}> behavior. With
    // `ssr: true`, wagmi defers persist rehydration AND gates EIP-6963 connector
    // discovery on `hasHydrated()` — both seeded initial providers and the mipd
    // subscriber early-return until rehydrate runs. `hydrate(...).onMount()`
    // rehydrates persistence, appends `mipd.getProviders()` into the connector
    // store, and then calls `reconnect(config)`. An embedding host owns this
    // lifecycle when it provides the config.
    if (!_external && typeof window !== 'undefined') {
        hydrate(_config, { reconnectOnMount: true }).onMount().catch(() => { });
    }
    return _config;
}
export function hasEvmConfig() {
    return _config !== null;
}
export function isExternalEvmConfig() {
    return _external;
}
